import { faker } from '@faker-js/faker';
import { generateFromEnum } from '@ingenico/api-sdk-core/mocks';
import type {
  DownloadOutputFileForTemplateV2QueryResponseApi,
  DownloadOutputFileV2QueryResponseApi,
  GetOutputFilenamesForDeploymentUnitBffV2QueryResponseApi,
  GetOutputFilenamesForDeploymentUnitV2QueryResponseApi,
  OutputFileContentApi,
  ParameterSetOutputFileApi,
  ParameterSetOutputFilesLogicalV2Api,
  ParameterSetListOutputFilesSearchBffV2Api,
  ParameterSetsOutputLogicalBffV2Api,
  ParameterSetsOutputLogicalV2Api,
  SearchOutputFilesBffV2MutationResponseApi,
} from '@ingenico/api-sdk-device-management-private-v2';
import { enumLogicalDeviceRole, enumOutputFileFormat } from '@ingenico/api-sdk-device-management-private-v2';
import type { HttpRequestResolverExtras, ResponseResolverInfo } from 'msw';
import { HttpResponse } from 'msw';
import {
  DEVICE_DETAILS_PARAMETER_SETS,
  getParameterSetIdsByIndex,
  getTemplateIdByIndex,
  NUMBER_TEMPLATES_PARAMETER_SETS,
} from './commonUuids';

const base64Mock = `
<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<ROOT version="cba.aus:14">
  <CurrentService>
    <current_service_idx id="current_service_idx">1</current_service_idx>
  </CurrentService>
  <ServiceConfigs>
    <ServiceConfig id="ServiceConfig">
      <index id="index">1</index>
      <service_name id="service_name">Retail</service_name>
      <industry_type id="industry_type">RETAIL</industry_type>
      <RefTransactionConfig id="RefTransactionConfig">
        <txn_index id="txn_index">1</txn_index>
      </RefTransactionConfig>
      <RefTransactionConfig id="RefTransactionConfig">
        <txn_index id="txn_index">2</txn_index>
      </RefTransactionConfig>
      <RefTransactionConfig id="RefTransactionConfig">
        <txn_index id="txn_index">3</txn_index>
      </RefTransactionConfig>
      <RefTransactionConfig id="RefTransactionConfig">
        <txn_index id="txn_index">4</txn_index>
      </RefTransactionConfig>
      <RefTransactionConfig id="RefTransactionConfig">
        <txn_index id="txn_index">5</txn_index>
      </RefTransactionConfig>
      <RefTransactionConfig id="RefTransactionConfig">
        <txn_index id="txn_index">6</txn_index>
      </RefTransactionConfig>
      <RefTransactionConfig id="RefTransactionConfig">
        <txn_index id="txn_index">7</txn_index>
      </RefTransactionConfig>
      <RefTransactionConfig id="RefTransactionConfig">
        <txn_index id="txn_index">8</txn_index>
      </RefTransactionConfig>
      <RefTransactionConfig id="RefTransactionConfig">
        <txn_index id="txn_index">9</txn_index>
      </RefTransactionConfig>
    </ServiceConfig>
  </ServiceConfigs>
  <TransactionConfigs>
    <TransactionConfig id="TransactionConfig">
      <index id="index">1</index>
      <txn_type id="txn_type">SALE</txn_type>
    </TransactionConfig>
    <TransactionConfig id="TransactionConfig">
      <index id="index">2</index>
      <txn_type id="txn_type">CASHOUT</txn_type>
    </TransactionConfig>
    <TransactionConfig id="TransactionConfig">
      <index id="index">3</index>
      <txn_type id="txn_type">REFUND</txn_type>
    </TransactionConfig>
    <TransactionConfig id="TransactionConfig">
      <index id="index">4</index>
      <txn_type id="txn_type">BANK_DEPOSIT</txn_type>
    </TransactionConfig>
    <TransactionConfig id="TransactionConfig">
      <index id="index">5</index>
      <txn_type id="txn_type">PRE_AUTH</txn_type>
    </TransactionConfig>
    <TransactionConfig id="TransactionConfig">
      <index id="index">6</index>
      <txn_type id="txn_type">PRE_AUTH_COMP</txn_type>
    </TransactionConfig>
    <TransactionConfig id="TransactionConfig">
      <index id="index">7</index>
      <txn_type id="txn_type">INCREMENTAL_AUTH</txn_type>
    </TransactionConfig>
    <TransactionConfig id="TransactionConfig">
      <index id="index">8</index>
      <txn_type id="txn_type">ACCOUNT_VERIFY</txn_type>
    </TransactionConfig>
    <TransactionConfig id="TransactionConfig">
      <index id="index">9</index>
      <txn_type id="txn_type">NO_SHOW</txn_type>
    </TransactionConfig>
  </TransactionConfigs>
  <HostCfgs>
    <HostCfg id="HostCfg">
      <index id="index">1</index>
      <RefOperation id="RefOperation">
        <operation_index id="operation_index">1</operation_index>
      </RefOperation>
      <RefOperation id="RefOperation">
        <operation_index id="operation_index">3</operation_index>
      </RefOperation>
      <comms_index id="comms_index">1</comms_index>
      <auth_token id="auth_token">DHVYZ3LEB1P6XWF09GFZCZK4I40HQBM0</auth_token>
      <haas id="haas">com.ingenico.apac.haas.cba</haas>
    </HostCfg>
  </HostCfgs>
  <CommsConfigs>
    <CommsConfig id="CommsConfig">
      <index id="index">1</index>
      <label id="label">Comms</label>
      <RefLinksConfig id="RefLinksConfig">
        <links_index id="links_index">1</links_index>
      </RefLinksConfig>
    </CommsConfig>
  </CommsConfigs>
  <LinksConfigs>
    <LinksConfig id="LinksConfig">
      <index id="index">1</index>
      <label id="label">Demo Link</label>
      <comms_net_type id="comms_net_type">WIFI</comms_net_type>
      <ssl_certs id="ssl_certs">CBACert.pem</ssl_certs>
      <tcp_primary_host_url_path id="tcp_primary_host_url_path">servlets/Transnox_API_server</tcp_primary_host_url_path>
      <tcp_primary_host_name id="tcp_primary_host_name">stagegw.transnox.com</tcp_primary_host_name>
      <tcp_primary_port id="tcp_primary_port">443</tcp_primary_port>
      <tcp_secondary_host_url_path id="tcp_secondary_host_url_path">servlets/Transnox_API_server</tcp_secondary_host_url_path>
      <tcp_secondary_host_name id="tcp_secondary_host_name">stagegw.transnox.com</tcp_secondary_host_name>
      <tcp_secondary_port id="tcp_secondary_port">443</tcp_secondary_port>
      <proxy_host_name id="proxy_host_name">www.proxy-example.com</proxy_host_name>
      <proxy_port id="proxy_port">0</proxy_port>
      <tcp_time_out id="tcp_time_out">30000</tcp_time_out>
      <tcp_read_time_out id="tcp_read_time_out">30000</tcp_read_time_out>
    </LinksConfig>
  </LinksConfigs>
  <Operations>
    <Operation id="Operation">
      <index id="index">1</index>
      <operation id="operation">Settlement</operation>
      <operation_type id="operation_type">MERCHANT_OPERATION</operation_type>
    </Operation>
    <Operation id="Operation">
      <index id="index">2</index>
      <operation id="operation">Clear Batch</operation>
      <operation_type id="operation_type">ADMIN_OPERATION</operation_type>
    </Operation>
    <Operation id="Operation">
      <index id="index">3</index>
      <operation id="operation">Batch Inquiry</operation>
      <operation_type id="operation_type">MERCHANT_OPERATION</operation_type>
    </Operation>
  </Operations>
  <Applications>
    <Application id="Application">
      <index id="index">1</index>
      <app_name id="app_name">Single Application</app_name>
      <app_package id="app_package">com.ingenico.ingp.standalone.cba</app_package>
    </Application>
  </Applications>
  <DefaultLanguage>
    <supported_language_idx id="supported_language_idx">1</supported_language_idx>
  </DefaultLanguage>
  <SupportedLanguagess>
    <SupportedLanguages id="SupportedLanguages">
      <index id="index">1</index>
      <language id="language">ENGLISH</language>
    </SupportedLanguages>
    <SupportedLanguages id="SupportedLanguages">
      <index id="index">2</index>
      <language id="language">SPANISH</language>
    </SupportedLanguages>
  </SupportedLanguagess>
  <NuaServiceConfig>
    <ws_port id="ws_port">8080</ws_port>
    <ws_type id="ws_type">WS</ws_type>
    <ws_server_mode_keystore id="ws_server_mode_keystore">NuaServer.bks</ws_server_mode_keystore>
    <ws_server_mode_truststore id="ws_server_mode_truststore">TrustedClient.bks</ws_server_mode_truststore>
    <ws_client_mode_keystore id="ws_client_mode_keystore">NuaClient.bks</ws_client_mode_keystore>
    <ws_client_mode_truststore id="ws_client_mode_truststore">TrustedServer.bks</ws_client_mode_truststore>
    <mode id="mode">Server</mode>
    <registration_server_url id="registration_server_url">cloudregisterexample.com</registration_server_url>
    <client_registration_port id="client_registration_port">50002</client_registration_port>
    <custom_data id="custom_data">{"biller_token": "12345", "tla": "abc"}</custom_data>
    <ssl_mutual_authentication id="ssl_mutual_authentication">false</ssl_mutual_authentication>
    <terminal_printer id="terminal_printer">false</terminal_printer>
    <preformatted_receipt id="preformatted_receipt">NONE</preformatted_receipt>
    <enable_suspend_events id="enable_suspend_events">false</enable_suspend_events>
    <enable_screen_info_events id="enable_screen_info_events">true</enable_screen_info_events>
    <hook_before_transaction id="hook_before_transaction">true</hook_before_transaction>
    <hook_after_total_amount id="hook_after_total_amount">true</hook_after_total_amount>
    <hook_dcc id="hook_dcc">true</hook_dcc>
    <hook_payment id="hook_payment">true</hook_payment>
    <hook_digital_receipt id="hook_digital_receipt">false</hook_digital_receipt>
    <hook_after_transaction id="hook_after_transaction">true</hook_after_transaction>
    <allow_standalone_transactions id="allow_standalone_transactions">false</allow_standalone_transactions>
  </NuaServiceConfig>
  <PersistSettingList>
    <persist_password_records id="persist_password_records">true</persist_password_records>
    <persist_clerk_records id="persist_clerk_records">true</persist_clerk_records>
    <persist_language_setting id="persist_language_setting">false</persist_language_setting>
    <persist_nua_setting id="persist_nua_setting">false</persist_nua_setting>
    <persist_credit_flow_setting id="persist_credit_flow_setting">false</persist_credit_flow_setting>
    <persist_debit_flow_setting id="persist_debit_flow_setting">false</persist_debit_flow_setting>
    <persist_merchant_receipt_line_setting id="persist_merchant_receipt_line_setting">false</persist_merchant_receipt_line_setting>
    <persist_prompt_setting id="persist_prompt_setting">false</persist_prompt_setting>
    <persist_receipt_print_setting id="persist_receipt_print_setting">false</persist_receipt_print_setting>
    <persist_credit_endorse_lines_setting id="persist_credit_endorse_lines_setting">false</persist_credit_endorse_lines_setting>
    <persist_credit_pin_lines_setting id="persist_credit_pin_lines_setting">false</persist_credit_pin_lines_setting>
    <persist_debit_endorse_lines_setting id="persist_debit_endorse_lines_setting">false</persist_debit_endorse_lines_setting>
    <persist_debit_pin_lines_setting id="persist_debit_pin_lines_setting">false</persist_debit_pin_lines_setting>
    <persist_tip_setting id="persist_tip_setting">false</persist_tip_setting>
    <persist_receipt_header_lines_setting id="persist_receipt_header_lines_setting">false</persist_receipt_header_lines_setting>
  </PersistSettingList>
  <ThemeConfig>
    <flavor_primary_color id="flavor_primary_color">#003C71</flavor_primary_color>
    <flavor_primary_dark_color id="flavor_primary_dark_color">#022E59</flavor_primary_dark_color>
    <flavor_primary_dark_color50p id="flavor_primary_dark_color50p">#7F022E59</flavor_primary_dark_color50p>
    <flavor_accent_color id="flavor_accent_color">#C4C4C4</flavor_accent_color>
  </ThemeConfig>
</ROOT>
`;

export function generateOutputFileContentApi(override?: Partial<OutputFileContentApi>): OutputFileContentApi {
  return {
    // fileFormat: generateFromEnum(enumOutputFileFormat),
    fileFormat: enumOutputFileFormat.XML,
    fileName: faker.system.fileName(),
    content: base64Mock,
    ...override,
  };
}

export function downloadOutputFileForTemplateV2ResponseMock(): DownloadOutputFileForTemplateV2QueryResponseApi {
  return generateOutputFileContentApi();
}

type DownloadOutputFileForTemplatePathParams = {
  deploymentUnitId: string;
  templateId: string;
  outputFileName: string;
};

export function downloadOutputFileForTemplateV2CustomHandler(
  context: ResponseResolverInfo<HttpRequestResolverExtras<DownloadOutputFileForTemplatePathParams>>,
) {
  return HttpResponse.json<DownloadOutputFileForTemplateV2QueryResponseApi>(
    generateOutputFileContentApi({ fileName: context.params.outputFileName }),
  );
}

type DownloadOutputFilePathParams = {
  deviceId: string;
  parameterSetId: string;
  outputFileName: string;
};

export function downloadOutputFileV2CustomHandler(
  context: ResponseResolverInfo<HttpRequestResolverExtras<DownloadOutputFilePathParams>>,
) {
  return HttpResponse.json<DownloadOutputFileV2QueryResponseApi>(
    generateOutputFileContentApi({ fileName: context.params.outputFileName }),
  );
}

export function generateParameterSetOutputFileApi(
  override?: Partial<ParameterSetOutputFileApi>,
): ParameterSetOutputFileApi {
  return {
    fileFormat: generateFromEnum(enumOutputFileFormat),
    fileName: faker.system.fileName(),
    ...override,
  };
}

export function generateParameterSetOutputFilesV2Api(
  override?: Partial<ParameterSetOutputFilesLogicalV2Api>,
): ParameterSetOutputFilesLogicalV2Api {
  return {
    outputFiles: faker.helpers.multiple(() => generateParameterSetOutputFileApi(), { count: 3 }),
    parameterSetId: faker.string.uuid(),
    templateId: faker.string.uuid(),
    ...override,
  };
}

function generateParameterSetsOutputV2Api(
  override?: Partial<ParameterSetsOutputLogicalV2Api>,
): ParameterSetsOutputLogicalV2Api {
  return {
    data: faker.helpers.multiple(() => generateParameterSetOutputFilesV2Api(), {
      count: faker.number.int({ min: 1, max: 5 }),
    }),
    ...override,
  };
}

export function getOutputFilenamesForDeploymentUnitV2ResponseMock(): GetOutputFilenamesForDeploymentUnitV2QueryResponseApi {
  return generateParameterSetsOutputV2Api();
}

export function getSpecificIdsForOutputFilenamesForDeploymentUnitV2ResponseMock(): GetOutputFilenamesForDeploymentUnitV2QueryResponseApi {
  return generateParameterSetsOutputV2Api({
    data: faker.helpers.multiple(
      (_, index) =>
        generateParameterSetOutputFilesV2Api({
          parameterSetId: getParameterSetIdsByIndex(index),
          templateId: getTemplateIdByIndex(index),
        }),
      {
        count: NUMBER_TEMPLATES_PARAMETER_SETS,
      },
    ),
  });
}

type LogicalDeviceRoleKey = 'logicalDeviceRole' | 'logicalDeviceRoleSnapshot';

const MOCKED_MULTI_MERCHANT_DEVICE_COUNT = 60;

function generateLogicalDeviceOutputFiles(roleKey: LogicalDeviceRoleKey, templateIndex: number, deviceCount: number) {
  return faker.helpers
    .multiple(
      (_, deviceIndex) => ({
        logicalDeviceId: faker.string.uuid(),
        logicalDeviceName: `Device ${deviceIndex + 1}`,
        [roleKey]:
          templateIndex === 0 && deviceIndex === 0 ? enumLogicalDeviceRole.PRIMARY : enumLogicalDeviceRole.STANDALONE,
      }),
      { count: deviceCount },
    )
    .flatMap((device, deviceIndex) =>
      faker.helpers.multiple(
        (_, fileIndex) => ({
          fileName: `template-${templateIndex + 1}-device-${deviceIndex + 1}-config-${fileIndex + 1}.xml`,
          fileFormat: enumOutputFileFormat.XML,
          ...device,
        }),
        { count: 2 },
      ),
    );
}

function generateLogicalDeviceOutputFilesData(
  roleKey: LogicalDeviceRoleKey,
  logicalDeviceCountForTemplate: (templateIndex: number) => number,
) {
  return faker.helpers.multiple(
    (_, templateIndex) => ({
      parameterSetId: getParameterSetIdsByIndex(templateIndex),
      templateId: getTemplateIdByIndex(templateIndex),
      templateName: faker.commerce.productName(),
      outputFiles: generateLogicalDeviceOutputFiles(
        roleKey,
        templateIndex,
        logicalDeviceCountForTemplate(templateIndex),
      ),
    }),
    { count: 2 },
  );
}

export function getOutputFilenamesForDeploymentUnitBffV2ResponseMock(): GetOutputFilenamesForDeploymentUnitBffV2QueryResponseApi {
  return {
    data: generateLogicalDeviceOutputFilesData('logicalDeviceRoleSnapshot', () => faker.number.int({ min: 1, max: 4 })),
  } satisfies ParameterSetsOutputLogicalBffV2Api;
}

export function searchOutputFilesBffV2ResponseMock(): SearchOutputFilesBffV2MutationResponseApi {
  const data = DEVICE_DETAILS_PARAMETER_SETS.map(({ parameterSetId, templateId }, parameterSetIndex) => ({
    parameterSetId,
    templateId,
    templateName: `Parameter template ${parameterSetIndex + 1}`,
    outputFiles: generateLogicalDeviceOutputFiles(
      'logicalDeviceRole',
      parameterSetIndex,
      parameterSetIndex === 0 ? MOCKED_MULTI_MERCHANT_DEVICE_COUNT : 1,
    ),
  }));

  return {
    pagination: {
      startIndex: 0,
      totalResults: data.length,
      itemsPerPage: 100,
    },
    data,
  } satisfies ParameterSetListOutputFilesSearchBffV2Api;
}
